import { Moment } from "moment";
import { Country } from "./country";
import { Language } from "./language";
import { School } from "./school";
import { Student } from "./student";

export class EtcBooking {

    constructor(
        public startDate: Moment,
        public endDate: Moment,
        public language: Language,
        public school: School,
        public country: Country,
        public firstName: string,
        public lastName: string
    ){}
}
